module.exports = __webpack_public_path__ + "img/xglhc_bg.6f8ab051.png";